<script lang="ts">
  import { link } from "svelte-routing"
  import { Button, Card, CardBody, CardSubtitle, CardTitle, Col, Container, Input, Row } from "sveltestrap"
  import { chainId, connected, selectedAccount, web3 } from "svelte-web3"
  import CategoryFilter from "../components/CategoryFilter.svelte"
  import NFTPriceInput from "../components/NFTPriceInput.svelte"
  import Image from "../components/Image.svelte"
  import PilTooltip from "../components/PilTooltip.svelte"
  import { Denominator, getNftImage, decodeDescriptionHash, getNftCollection } from "../utils/utils"
  import { ERC721ABI } from "../abis/erc721"
  import { INITIAL_ROUNDS, PIL } from "../stores/constants"
  import { COREABI } from "../abis/core"
  import { pairListSelectedCategories, tokenAddress, uploadDone } from "../stores/store"
  import { CONFIG } from "../config"
  import TxModal from "../components/TxModal.svelte"
  import { onMount } from "svelte"

  export let address: string
  export let id: string

  let phase = 'input' // input, submit
  let selectedToken = PIL;
  let price: number;
  let title = '';
  let description = '';
  let approveHash = '';
  let uploadHash = '';
  let collection = '';
  let approved = false;
  let descriptionHash = '';
  let image = '';
  let approveDisabled = false;
  let approveModalOpen = false;
  let uploadDisabled = false;
  let uploadModalOpen = false;
  let selectedCategories = [];
  let y;

  if (!$connected) {
    window.location.href = '/upload'
  }

  onMount(() => {
    y = 0;
  })

  const getInfo = async () => {
    const nftContract = new $web3.eth.Contract(ERC721ABI, address);
    const collection = await getNftCollection(nftContract);
    title = `${collection} #${id}`;

    const approvedAddr = await nftContract.methods.getApproved(id).call();
    approved = approvedAddr.toLowerCase() === CONFIG[$chainId].CORE_ADDRESS.toLowerCase();
  }

  const approve = async () => {
    const nftContract = new $web3.eth.Contract(ERC721ABI, address);
    nftContract.methods.approve(CONFIG[$chainId].CORE_ADDRESS, id).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        approveHash = hash;
        approveDisabled = true;
        approveModalOpen = true;
      })
      .on('receipt', receipt => {
        console.log(receipt);
        approved = true;
        approveDisabled = false;
      })
  }

  const addIpfs = async () => {
    const formData = new FormData()
    formData.append('blob', new Blob([description]), 'description')
    const data = await (await fetch('https://ipfs.infura.io:5001/api/v0/add', {
      method: 'POST',
      body: formData
    })).json();
    descriptionHash = decodeDescriptionHash(data['Hash']);
  }

  const upload = async () => {
    await addIpfs();
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    const listingPrice = $web3.utils.toBN(Math.round(price / INITIAL_ROUNDS * Math.pow(10, selectedToken.decimals)).toLocaleString('fullwide', { useGrouping: false }));
    const tags = selectedCategories;
    pilgrim.methods.list(
      address,
      id,
      listingPrice,
      $tokenAddress[selectedToken.symbol],
      tags,
      descriptionHash
    ).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        uploadHash = hash;
        uploadDisabled = true;
        uploadModalOpen = true;
      })
      .on('receipt', receipt => {
        console.log(receipt);
        phase = 'submit';
        uploadDone.set(true);
        uploadDisabled = false;
      })
  }

  $: if ($connected) {
    getInfo();
    getNftImage($chainId, address, Number.parseInt(id))
      .then(res => image = res);
  }

  const selectCategory = (category) => {
    selectedCategories = [category];
  }

  const removeCategory = () => {
    selectedCategories = [];
  }
</script>

<Row>
  <div class="page-header"/>
</Row>
<Container>
  <Row>
    <Col class="page-title">
      Upload NFT
    </Col>
  </Row>
  {#if phase === 'input'}
    <Row>
      <Col class="upload-back">
        <a href="javascript:window.history.back();">
          <img class="icon-large upload-back-icon" src="/icons/arrow-left.svg" alt="placeholder"/>
        </a>
        Back to list
      </Col>
    </Row>
    <Row>
      <Col class="upload-subtitle">
        Input listing information
      </Col>
    </Row>
    <Row class="gy-3">
      <Col lg="5">
        <div class="nft-detail-thumbnail">
          <Image src={image}/>
        </div>

<!--        <img class="nft-detail-thumbnail" src={image} alt="placeholder" onerror="this.src='/placeholder.svg'"/>-->
      </Col>
      <Col lg="1"/>
      <Col lg="6">
        <Row>
          <Card class="upload-detail-card">
            <CardBody>
              <Row>
                <Col>
                  <p class="upload-detail-title">Item details</p>
                </Col>
              </Row>
              <Row class="align-items-center">
                <Col>
                  <p class="upload-detail-subtitle">Item Name</p>
                </Col>
                <Col class="text-end">
                  <img class="icon-small upload-detail-subtitle" src="/icons/question.svg" alt="placeholder"/>
                </Col>
              </Row>
              <Row>
                <Col>
                  {title}
                </Col>
              </Row>
              <Row class="align-items-center">
                <Col>
                  <p class="upload-detail-subtitle">Short description <span class="negative">*</span></p>
                </Col>
                <Col class="text-end">
                  <img class="icon-small upload-detail-subtitle" src="/icons/question.svg" alt="placeholder"/>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input
                    type="textarea"
                    class="pil-input pil-input-textarea"
                    placeholder="Write a short description about the NFT."
                    bind:value={description}
                  />
                </Col>
              </Row>
              <Row class="align-items-center">
                <Col>
                  <p class="upload-detail-subtitle">Category (select one) <span class="negative">*</span></p>
                </Col>
                <Col class="text-end">
                  <img class="icon-small upload-detail-subtitle" src="/icons/question.svg" alt="placeholder"/>
                </Col>
              </Row>
              <Row>
                <CategoryFilter inlineButton="{true}" {selectedCategories} {selectCategory} {removeCategory} />
              </Row>
            </CardBody>
          </Card>
        </Row>
        <Row>
          <Card class="upload-price-card">
            <Row class="upload-card-margin">
            </Row>
            <CardBody class="upload-card-body">
              <Row>
                <Col>
                  <p class="upload-detail-title">Price setup</p>
                </Col>
              </Row>
              <Row class="align-items-center">
                <Col>
                  <p class="upload-detail-subtitle">Listing price <span class="negative">*</span></p>
                </Col>
                <Col class="text-end">
                  <PilTooltip class="upload-detail-subtitle" tooltipId="upload-listing-price">
                    This is the initial spot price of the NFT.
                    The price of this NFT will only increase from this point, based on demand for rounds.
                  </PilTooltip>
                </Col>
              </Row>
              <Row>
                <Col>
                  <NFTPriceInput bind:selectedToken={selectedToken} bind:value={price}/>
                </Col>
              </Row>
              <Row class="align-items-center upload-round-price">
                <Col>
                  <p class="upload-round-price-label">Your initial price per round <img class="icon-small" src="/icons/question.svg" alt="placeholder"/></p>
                </Col>
                <Col class="text-end upload-round-price-value">
                  {price / INITIAL_ROUNDS} {selectedToken.symbol}
                </Col>
              </Row>
              <Row>
                <Col>
                  {#if approved}
                    <Button class="upload-connect upload-button" on:click={upload} disabled={uploadDisabled || selectedCategories.length === 0}>
                      {#if selectedCategories.length === 0}
                        Select a category
                      {:else}
                        Upload
                      {/if}
                    </Button>
                    <TxModal msg="Upload transaction initiated" txHash={uploadHash} isOpen={uploadModalOpen}/>
                  {:else}
                    <Button class="upload-connect upload-button" on:click={approve} disabled={approveDisabled || selectedCategories.length === 0}>
                      {#if selectedCategories.length === 0}
                        Select a category
                      {:else}
                        Approve
                      {/if}
                    </Button>
                    <TxModal msg="Approve transaction initiated" txHash={approveHash} isOpen={approveModalOpen}/>
                  {/if}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </Col>
    </Row>
  {:else if phase === 'submit'}
    <Row>
      <Col class="text-center upload-result-title">
        <span>
          <img class="icon-medium" src="/icons/check-circle.svg" alt="placeholer"/>
        </span>
        <span>
          Your NFT is successfully listed in Pilgrim
        </span>
      </Col>
    </Row>
    <Row class="justify-content-center">
      <Col sm="4">
        <Card class="mb-3 nftCard">
          <Image class="nftCard-thumbnail" src={getNftImage($chainId, address, Number.parseInt(id))} />
          <CardBody class="nftCard-body uploadCard-body">
            <CardSubtitle class="nftCard-collection">{collection}</CardSubtitle>
            <CardTitle class="nftCard-title">{title}</CardTitle>
          </CardBody>
        </Card>
      </Col>
    </Row>
    <Row>
      <Col class="text-center">
        <a href="/portfolio/positions" use:link>
          <Button class="button-line upload-listed-nft-button">
            See my portfolio
          </Button>
        </a>
      </Col>
    </Row>
  {/if}

</Container>
<svelte:window bind:scrollY={y} />
